<button mat-icon-button color="warn" aria-label="delete tag" (click)="openDialog()">
  <mat-icon>delete</mat-icon>
</button>